import { useMe } from '../api/hooks';
import Dashboard from '../components/Dashboard';

export default function Home() {
  const { data: me } = useMe();

  return (
    <>
      {me && (
        <h2 style={{ alignSelf: 'flex-start' }}>
          Welcome, {me.displayName}
        </h2>
      )}
      <Dashboard />
    </>
  );
}
